import { getUrlData } from './project-cards';
import {FilterCategories, FilterCategory} from "../typings/backend-models";
interface CreateFilter {
    mainElement: HTMLElement;
    initialActiveCategoriesIds?: number[];
    onSubmit: (categoriesIds: number[]) => void;
    filterCategories: FilterCategories;
    abortText: string;
    submitText: string;
    filterChooseText: string;
    filterTitle: string;
    isAsync: Boolean;
    language: string;
}

const filterSideNav = () => {
    const filterComponentEl = document.querySelector('.filter-component');
    if (!filterComponentEl) return;     
    const isExpanded = (element: Element): Boolean => {
        return element.classList.contains('expanded');
    };

    const sideNavElement = filterComponentEl.querySelector('.filter-side-nav');
    const desktopButton = sideNavElement.querySelector('.filter-side-nav__button-desktop');
    const mobileButton = sideNavElement.querySelector('.filter-side-nav__button-mobile');
    const activeButton = filterComponentEl.querySelector('.filter-active-button');

    const filterDefaultText = 'Filter';
    const { closeText } = (activeButton as HTMLElement).dataset;

    activeButton.addEventListener('click', function () {
        if (isExpanded(sideNavElement)) {
            sideNavElement.classList.remove('expanded');
            activeButton.textContent = filterDefaultText;
            activeButton.classList.remove('button--primary__active');
            desktopButton.classList.remove('button--primary__active');
        } else {
            sideNavElement.classList.add('expanded');
            activeButton.textContent = closeText;
            activeButton.classList.add('button--primary__active');
            desktopButton.classList.add('button--outline__active');
        }
    });

    mobileButton.addEventListener('click', function () {
        activeButton.textContent = filterDefaultText;
        sideNavElement.classList.remove('expanded');
        activeButton.classList.remove('button--primary__active');
        desktopButton.classList.remove('button--outline__active');
    });

    desktopButton.addEventListener('click', function () {
        if (isExpanded(sideNavElement)) {
            sideNavElement.classList.remove('expanded');
            activeButton.textContent = filterDefaultText;
            desktopButton.setAttribute('aria-label', 'Filter');
            activeButton.classList.remove('button--primary__active');
            desktopButton.classList.remove('button--outline__active');
        } else {
            sideNavElement.classList.remove('hovered');
            sideNavElement.classList.add('expanded');
            activeButton.textContent = closeText;
            desktopButton.setAttribute('aria-label', desktopButton.getAttribute('data-db-close-text'));
            activeButton.classList.add('button--primary__active');
            desktopButton.classList.add('button--outline__active');
        }
    });
    desktopButton.addEventListener('mouseover', function () {
        if (!isExpanded(sideNavElement)) {
            sideNavElement.classList.add('hovered');
        }
    });
    desktopButton.addEventListener('mouseleave', function () {
        if (!isExpanded(sideNavElement)) {
            sideNavElement.classList.remove('hovered');
        }
    });
};

const createFilter = (props: CreateFilter): void => {
    const { mainElement, initialActiveCategoriesIds, onSubmit, submitText, abortText, filterChooseText, filterCategories, filterTitle, isAsync, language } = props;

    let activeCategoryIds: number[] = initialActiveCategoriesIds || [];

    const createMainCategory = (category: FilterCategory) => {
        const wrapper = createSubcategory(category);

        const labelEl = document.createElement('h4');
        labelEl.classList.add('filter-item__label');
        labelEl.textContent = category.name;

        wrapper.prepend(labelEl);

        return wrapper;
    };

    const createSingleItem = (category: FilterCategory) => {
        const catIdNum = Number(category.id);

        const item = document.createElement('li');
        item.classList.add('filter-item');
        item.classList.add('filter-item__selectable');
        item.setAttribute('data-id', category.id.toString());

        const itemContentEl = document.createElement('label');
        itemContentEl.textContent = category.name;
        itemContentEl.setAttribute('for', 'cat' + category.id);
        const checkboxEl = document.createElement('input');
        checkboxEl.setAttribute('type', 'checkbox');
        checkboxEl.classList.add('filter-item__checkbox');
        checkboxEl.setAttribute('value', itemContentEl.textContent);
        checkboxEl.setAttribute('name', itemContentEl.textContent);
        checkboxEl.setAttribute('id', 'cat' + category.id);
        
        item.append(checkboxEl);
        item.append(itemContentEl);

        if (activeCategoryIds.indexOf(catIdNum) > -1) {
            item.classList.add('active');
            checkboxEl.checked = true;
            createFilterListItem(catIdNum, category.name);
        }

        checkboxEl.addEventListener('click', function () {
            const isActive: Boolean = !checkboxEl.checked;
            if (isActive) {
                removeFilter(catIdNum);
            } else {
                addFilter(catIdNum, category.name);
            }
        });
        return item;
    };

    const createSubcategory = (category: FilterCategory) => {
        const { name, categories, id } = category;
        const isMainCategory = category.isTopCategoryInFilter;

        const wrapper = isMainCategory ? document.createElement('div') : document.createElement('li');
        wrapper.classList.add('filter-item');

        const panel = document.createElement('ul');
        panel.setAttribute('id', "parentname-"+name);
        if (!isMainCategory) {

            const item = document.createElement('li');
            item.classList.add('filter-item');
            item.classList.add('filter-item__selectable');
            item.setAttribute('data-id', "data"+id.toString());

            const itemContentEl = document.createElement('label');
            
            if (language === "20"){
                itemContentEl.textContent = "Velg Alle";
            }
            else if (language === "29"){
                itemContentEl.textContent = "Välj Alla";
            }
            else{
                itemContentEl.textContent = "Select All";
            }
            itemContentEl.setAttribute('for', 'SelectAll' + name);
            itemContentEl.setAttribute('id', 'SelectAll' + id);

            itemContentEl.classList.add('highligtedFont');
            const checkboxEl = document.createElement('input');
            checkboxEl.setAttribute('type', 'checkbox');
            checkboxEl.classList.add('filter-item__checkbox');
            checkboxEl.setAttribute('value', "select all"+name);
            checkboxEl.setAttribute('name', "select all" + name);
            checkboxEl.setAttribute('id', 'SelectAll' + name);
            item.append(checkboxEl);
            item.append(itemContentEl);

            panel.append(item)

            checkboxEl.addEventListener('click', function () {
                const isActive: Boolean = !checkboxEl.checked;
                var childs = document.getElementById("parentname-" + name).childNodes;
                childs.forEach(child => {
                    var tmp = child.childNodes
                    const inputLabel = tmp[1] as HTMLInputElement;
                    const inputChecker = tmp[0] as HTMLInputElement;
                    const isChildActive: Boolean = !inputChecker.checked;
    
                    if (inputLabel != null) {
                        if (isActive) {
                            if (inputLabel.id != 'SelectAll' + id) {
                                if (!isChildActive) {
                                    inputLabel.click();
                                }   
                            }
                        }
                        else if (!isActive){
                            if (inputLabel.id != 'SelectAll' + id) {
                                if (isChildActive) {
                                    inputLabel.click();
                                }
                            }
                        }
                    }
                }
                )
            });
        }
        panel.classList.add('filter-item__panel');
        panel.classList.add('filter-item__panel--first-level');
        panel.classList.add('hide');
        // const panelList = document.createElement('ul');
        // panelList.classList.add('filter-item__panel-list');
        // panel.append(panelList);

        const btn = document.createElement('button');
        btn.classList.add('filter-item__accordion');
        btn.classList.add('filter-item__accordion--first');

        if (isMainCategory) {
            
            btn.textContent = filterChooseText;
            btn.setAttribute('id', id.toString());
            wrapper.classList.add('filter-item__main');
        } else {
            btn.textContent = name;
            btn.setAttribute('ids', id.toString());
        }

        btn.addEventListener('click', function () {
            this.classList.toggle('active');
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                panel.classList.add('hide');
                btn.setAttribute('aria-expanded', 'false');
            } else {
                panel.style.maxHeight = '1600px';
                btn.setAttribute('aria-expanded', 'true');
                panel.classList.remove('hide');
            }
        });

        if (categories != null) {
            categories.forEach((subcategory) => {
                const isSingleItem = subcategory.categories === null;
                const isSubcategory = !isSingleItem;

                const isAllWithin = subcategory.isAllWithin;

                if (isSingleItem) {
                    const item = createSingleItem(subcategory);
                    panel.append(item);
                } else if (isSubcategory) {
                    const items = createSubcategory(subcategory);
                    panel.append(items);
                } else if (isAllWithin) {
                    const item = createSingleItem(subcategory);
                    panel.append(item);
                }
            });
        }

        wrapper.append(btn);
        wrapper.append(panel);

        return wrapper;
    };

    const removeFilter = (id: number) => {
        const filterItem = document.querySelectorAll(`.filter-item__selectable[data-id="${id.toString()}"]`)[0];
        const filterCheckbox = filterItem.querySelector('.filter-item__checkbox') as HTMLInputElement;

        filterCheckbox.checked = false;
        activeCategoryIds = activeCategoryIds.filter((num) => num !== id);
        filterItem.classList.remove('active');
        removeFilterListItem(id);
    };

    const addFilter = (id: number, name: string) => {
        const filterItem = document.querySelectorAll(`.filter-item__selectable[data-id="${id.toString()}"]`)[0];
        const filterCheckbox = filterItem.querySelector('.filter-item__checkbox') as HTMLInputElement;

        createFilterListItem(id, name);

        filterCheckbox.checked = true;
        filterItem.classList.add('active');
        activeCategoryIds.push(id);
    };

    const removeAllFilters = () => {
        activeCategoryIds.forEach((catId) => {
            removeFilter(catId);
        });
    };

    const resetCategories = (isAsync: Boolean) => {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete('catids');
        searchParams.delete('page');
        url.search = searchParams.toString();

        const desktopButton = document.querySelector('.filter-side-nav__button-desktop') as HTMLButtonElement;
        desktopButton.click();

        if (isAsync) {
            removeAllFilters();
            history.pushState({}, null, url.toString());
        } else {
            window.open(url.href, '_self');
        }
    };

    const createFilterListItem = (id: number, name: string) => { 
        const activeFiltersList = document.querySelector('.filter-active-list');
        const filterListEl = document.createElement('li');
        const filterListBtn = document.createElement('button');
        
        filterListBtn.setAttribute('type', 'button');
        filterListBtn.classList.add('filter-active-list__button');
        filterListBtn.textContent = name;
        filterListBtn.setAttribute('data-id', id.toString());
   
        filterListEl.classList.add('filter-active-list__item');
        filterListEl.setAttribute('data-id', id.toString());

        filterListBtn.addEventListener('click', function () {
            removeFilter(id);
        });
        filterListBtn.innerHTML = `${filterListBtn.innerHTML} <sup>&#10005;</sup>`;

        filterListEl.append(filterListBtn);

        activeFiltersList.prepend(filterListEl);
    };

    const removeFilterListItem = (id: number) => {
        const filterListItem = document.querySelectorAll(`.filter-active-list__item[data-id="${id.toString()}"]`)[0];

        filterListItem.remove();
    };

    const createFiltersList = (categories: FilterCategory[], submitText: string, abortText: string, filterChooseText: string, filterTitle: string) => {
        const filterWrapperEl = mainElement;
 
        const filters: Element[] = [];

        const filterListEl = document.createElement('div');
        filterListEl.classList.add('filter-list');
        
        const buttonsWrapperEl = document.createElement('div');
        buttonsWrapperEl.classList.add('filter-buttons');

        const submitButton = document.createElement('button');
        submitButton.classList.add('filter-button');
        submitButton.classList.add('button');
        submitButton.classList.add('filter-button--submit');
        submitButton.classList.add('button--negative');
        submitButton.textContent = submitText;
        submitButton.addEventListener('click', () => onSubmit(activeCategoryIds));

        const abortButton = document.createElement('button');
        abortButton.classList.add('filter-button');
        abortButton.classList.add('button');
        abortButton.classList.add('button--outline-negative');
        abortButton.classList.add('filter-button--abort');
        abortButton.textContent = abortText;
        abortButton.addEventListener('click', () => resetCategories(isAsync));

        buttonsWrapperEl.append(submitButton, abortButton);

        categories.map((category) => {
            const firstItemEl = createMainCategory(category);
            filterListEl.append(firstItemEl);
            filters.push(filterListEl);
        });

        filters.forEach((filter) => {
            filterWrapperEl.prepend(filter);
        });
        filterWrapperEl.append(buttonsWrapperEl);

        const filterTitleEl = document.createElement('h2');
        filterTitleEl.textContent = filterTitle;
        filterTitleEl.classList.add("filter-title");
        filterWrapperEl.prepend(filterTitleEl);
    };

    createFiltersList(filterCategories.categories, submitText, abortText, filterChooseText, filterTitle);
};

const getCategories = async (url: string) => {
    const res = await fetch(url).then((response) => response.json());
    return res;
};

const updateCategories = (categories: number[], isAsync: Boolean) => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    searchParams.delete('catids');
    searchParams.delete('page');
    categories.forEach((category) => searchParams.append('catids', category.toString()));
    url.search = searchParams.toString();

    const desktopButton = document.querySelector('.filter-side-nav__button-desktop') as HTMLButtonElement;
    desktopButton.click();

    if (isAsync) {
        history.pushState({}, null, url.toString());
    } else {
        window.open(url.href, '_self');
    }
};

const initializeFilters = () => {
    const filterBoxsEl = document.querySelector('.filter-box');
    if (!filterBoxsEl) return;
    const data = (filterBoxsEl as HTMLElement).dataset;
    const { guuid, lang, abortText, submitText, filterChooseText, filterTitle, isAsync } = data;
    const isFilterAsync: Boolean = isAsync ? isAsync.toLowerCase() === 'true' : false;
    const { catIds } = getUrlData();

    const mainUrl: string = window.location.origin;
    const apiUrl: string = `${mainUrl}/api/filter/categories/${guuid}/${lang}`;

    getCategories(apiUrl).then((filterCategories: FilterCategories) => {
        createFilter({
            mainElement: filterBoxsEl as HTMLElement,
            onSubmit: (categories) => updateCategories(categories, isFilterAsync),
            filterCategories,
            initialActiveCategoriesIds: catIds,
            submitText,
            abortText,
            filterChooseText, 
            filterTitle, 
            isAsync: isFilterAsync,
            language: lang,
        });
    });
};

filterSideNav();
initializeFilters();

export default createFilter;
